import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { FOUNDING_CAP } from "@/lib/pricing";

type FoundingStatus = {
  remaining: number;
  cap: number;
  soldOut: boolean;
  loading: boolean;
};

/**
 * Live count of remaining Founding Member spots (out of 250). Used by the
 * paywall to show "Only X spots left" and to hide the Founding tier once
 * sold out. Cached for 60s server-side, so we can call it freely.
 */
export const useFoundingStatus = (): FoundingStatus => {
  const [state, setState] = useState<FoundingStatus>({
    remaining: FOUNDING_CAP,
    cap: FOUNDING_CAP,
    soldOut: false,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    supabase.functions
      .invoke("founding-status", { body: {} })
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error || !data) {
          setState({ remaining: FOUNDING_CAP, cap: FOUNDING_CAP, soldOut: false, loading: false });
          return;
        }
        setState({
          remaining: Number(data.remaining) || 0,
          cap: Number(data.cap) || FOUNDING_CAP,
          soldOut: Boolean(data.soldOut),
          loading: false,
        });
      })
      .catch(() => {
        if (!cancelled) {
          setState({ remaining: FOUNDING_CAP, cap: FOUNDING_CAP, soldOut: false, loading: false });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
};
